import Vue from 'vue';

export default {
  // 重置密码
  updatePassWord (params) {
    return Vue.axios.post('/api/v1.0/chanquan/user/forgetPassWord', params);
  },
  // 验证短信验证码
  authenticate (params) {
    return Vue.axios.post('/api/v1.0/chanquan/user/authenticate', params);
  }

};
